import * as moment from 'moment';
import { Moment, Duration } from 'moment';

export class Segment {
  constructor(
    public readonly carrierCode: string,
    public readonly flightNumber: number,
    public readonly departureDate: Moment,
    public readonly departureUtc: Moment,
    public readonly arrivalUtc: Moment,
    public readonly departureLocal: Moment,
    public readonly arrivalLocal: Moment,
    public readonly originCode: string,
    public readonly destinationCode: string,
    public readonly delayMinutes: Duration,
    public readonly operatedBy: string,
    public readonly delayCode?: string,
  ) {}

  public get flightDuration(): Duration {
    return moment.duration(this.arrivalUtc.diff(this.departureUtc));
  }
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/models/segment.ts